import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { OrderSupportTicketLink, OrderSupportThreadLink, SupportService } from '../api';

// ============================================================================
// Support panel a rendelés oldal jobb oszlopában: a rendeléshez kötött taskok és
// levelezések — kattintásra a taskra / levelezésre visz. Ha nincs kapcsolat, nem látszik.
// ============================================================================

const PRIORITY_CLASS: Record<string, string> = { P1: 'sup-prio--p1', P2: 'sup-prio--p2', P3: 'sup-prio--p3' };
const MAIL_STATUS: Record<string, string> = { open: 'Nyitott', closed: 'Lezárt' };

@Component({
  selector: 'app-order-support-panel',
  templateUrl: './order-support-panel.component.html',
  styleUrl: './order-support-panel.component.scss',
})
export class OrderSupportPanelComponent implements OnChanges {
  @Input() orderId?: number | null;

  tickets: OrderSupportTicketLink[] = [];
  threads: OrderSupportThreadLink[] = [];
  loaded = false;

  constructor(private support: SupportService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['orderId']) {
      this.load();
    }
  }

  private load(): void {
    const id = Number(this.orderId);
    this.tickets = [];
    this.threads = [];
    this.loaded = false;
    if (!id) {
      return;
    }
    this.support.getOrderLinks(id).subscribe({
      next: (links) => {
        if (Number(this.orderId) !== id) {
          return;
        }
        this.tickets = links.tickets || [];
        this.threads = links.threads || [];
        this.loaded = true;
      },
      // nincs jogosultság / hiba: a panel egyszerűen nem jelenik meg
      error: () => (this.loaded = true),
    });
  }

  get total(): number {
    return this.tickets.length + this.threads.length;
  }

  get openTickets(): number {
    return this.tickets.filter((t) => !t.done).length;
  }

  prioClass(p: string): string {
    return PRIORITY_CLASS[p] || '';
  }

  mailStatus(t: OrderSupportThreadLink): string {
    return MAIL_STATUS[t.status] || t.status;
  }

  assigneeLabel(t: OrderSupportTicketLink): string {
    if (!t.assignees.length) {
      return 'Nincs felelős';
    }
    return t.assignees.length > 2 ? `${t.assignees.slice(0, 2).join(', ')} +${t.assignees.length - 2}` : t.assignees.join(', ');
  }

  /** ma → 14:32, idén → szept. 21., régebben → 2025. márc. 3. */
  when(iso: string | null): string {
    if (!iso) {
      return '';
    }
    const d = new Date(iso);
    const now = new Date();
    if (d.toDateString() === now.toDateString()) {
      return d.toLocaleTimeString('hu-HU', { hour: '2-digit', minute: '2-digit' });
    }
    return d.toLocaleDateString('hu-HU', { year: d.getFullYear() === now.getFullYear() ? undefined : 'numeric', month: 'short', day: 'numeric' });
  }
}
